// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1__e344ac000d1f2a0425e5","cls2":"Unibrow-cls2___858f8c4f1e85ac42840 Unibrow-cls1__e344ac000d1f2a0425e5"};